<template>
  <div id="SelectSeatingArea">
    <div class="left">
      <div class="left__title">select seating area</div>
      <div class="seating-table">
        <div class="seating-table__row seating-table__row-title">
          <div class="item itemTitle"></div>
          <div class="item early-bird">
            <!-- <div class="big">early bird pricing</div>
            <div class="small">Offer ends January 1</div> -->
          </div>
          <div class="item regular">
            <!-- <div class="big">regular<br />pricing</div> -->
            <div class="big">group<br />pricing</div>
          </div>
        </div>
        <div
          class="seating-table__row seating-table__row-content"
          v-for="(seat, index) in seatingData"
          :key="seat.class + index"
          :style="{ 'border-left-color': seat.color }"
          :class="[{ active: seat.active }, seat.class]"
          @click="activeClass(index)"
        >
          <div class="item itemTitle" v-if="seat.class == 'allAreas'">
            {{ seat.title }}
            <img
              src="@/assets/icons/icon_small-arrow.svg"
              v-if="seat.class === 'allAreas'"
            />
          </div>
          <div
            class="item itemTitle"
            v-html="seat.htmltitle"
            v-else-if="seat.htmltitle"
          ></div>
          <div class="item itemTitle" v-else>{{ seat.title }}</div>
          <div class="item early-bird" v-if="seat.earlyBird">
            <div class="light">Starting at</div>
            <div class="early-bird__right">
              ${{ seat.earlyBird }}*
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item early-bird" v-else></div>
          <div class="item regular start" v-if="seat.regularOnlyStart">
            <div class="light start">Starting at</div>
            <div class="regularOnly-right">
              <div class="regularOnly">${{ seat.regularOnlyStart }}</div>
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item regular" v-else-if="seat.regularOnly">
            <div class="item-holder">
              <div class="regularOnly">${{ seat.regularOnly }}</div>
              <div class="light">Per Person</div>
            </div>
          </div>
          <div class="item regular" v-else-if="seat.regular">
            <div class="strike">${{ seat.regular }}</div>
            <div class="light">Per Person</div>
          </div>
          <div class="item regular tbd" v-else-if="seat.tbd">
            <div class="item-holder">
              <div class="regularOnly">{{ seat.tbd }}</div>
              <!-- <div class="light">Per Person</div> -->
            </div>
          </div>
          <div class="item regular soldOut" v-else-if="seat.soldOut">
            <div class="item-holder">
              <div class="regularOnly">Sold Out</div>
            </div>
          </div>
          <div class="item regular" v-else></div>
        </div>
      </div>
      <div class="left-disclaimer">
        <!-- <div class="left-disclaimer__title">early bird pricing</div> -->
        <!-- <div class="left-disclaimer__copy first">
          Book your group or place a 50% deposit during the early booking window
          and take advantage of the lowest possible group pricing during the
          2022 season.
        </div> -->
        <div class="left-disclaimer__copy">
          All Texas Rangers tickets are subject to dynamic pricing - supply and
          demand causes pricing to fluctuate. Check with your Texas Rangers
          group ticket representative for the most up to the minute pricing or
          call 972-Rangers x 3 to book your group tickets at the current lowest
          price possible.
          <br /><br />
          All Texas Rangers Groups Tickets are digital.
          <br /><br />
          <span
            >The resale of group tickets is strictly prohibited and could result
            in the loss of group ticket privileges.</span
          >
          <br /><br />
          *Applicable fees and taxes to be added at time of purchase.
        </div>
      </div>
    </div>
    <div class="right">
      <template v-for="(seatInfo, ind) in seatingData">
        <div
          class="seating-info"
          :key="'info' + seatInfo.class + ind"
          v-if="seatInfo.active"
        >
          <img
            @click="(mapModal = true), (activeMap = seatInfo.map)"
            class="map"
            :src="seatInfo.map"
          />
          <div
            class="seating-info__title"
            :style="{ 'border-left-color': seatInfo.color }"
            v-html="seatInfo.title"
            v-if="seatInfo.class !== 'allAreas'"
          />
          <div class="seating-info__middle double" v-if="seatInfo.description">
            <p>{{ seatInfo.description }}</p>
            <div class="right-info">
              <div class="right-info__item" v-if="seatInfo.heading">
                {{ seatInfo.heading }}
              </div>
              <div class="right-info__item">
                <div class="image">
                  <img src="@/assets/icons/icon_blue-small_pin-location.svg" />
                </div>
                <p v-html="seatInfo.sections"></p>
              </div>
              <div class="right-info__item" v-if="seatInfo.capacity">
                <div class="image">
                  <img src="@/assets/icons/icon_blue-small_ticket.svg" />
                </div>
                capacity <span>{{ seatInfo.capacity }}</span>
              </div>
              <div class="right-info__item" v-if="seatInfo.price">
                <div class="image">
                  <img src="@/assets/icons/icon_blue-small_dollar-sign.svg" />
                </div>
                <p v-html="seatInfo.price"></p>
              </div>
              <div class="right-info__item legal" v-if="seatInfo.legal">
                <div class="image" />
                {{ seatInfo.legal }}
              </div>
            </div>
          </div>
          <div class="seating-info__middle single" v-else>
            <div class="single__item" v-if="seatInfo.sections">
              <div class="image">
                <img src="@/assets/icons/icon_blue-small_pin-location.svg" />
              </div>
              <p v-html="seatInfo.sections"></p>
            </div>
            <div class="single__item" v-if="seatInfo.capacity">
              <div class="image">
                <img src="@/assets/icons/icon_blue-small_ticket.svg" />
              </div>
              capacity <span>{{ seatInfo.capacity }}</span>
            </div>
            <div class="single__item" v-if="seatInfo.price">
              <div class="image">
                <img src="@/assets/icons/icon_blue-small_dollar-sign.svg" />
              </div>
              <p v-html="seatInfo.price"></p>
            </div>
            <div class="single__item legal" v-if="seatInfo.price">
              <div class="image" />
              {{ seatInfo.legal }}
            </div>
          </div>
          <div class="seating-info__carousel" v-if="seatInfo.carousel">
            <b-carousel
              id="SeatingAreaCarousel"
              controls
              v-if="seatInfo.carousel.length > 1"
            >
              <b-carousel-slide
                v-for="(image, i) in seatInfo.carousel"
                :key="'image' + seatInfo.class + i"
                :img-src="image"
              />
            </b-carousel>
            <img
              class="seating-info__carousel-image"
              v-else-if="(seatInfo.carousel.length = 1)"
              :src="seatInfo.carousel"
            />
          </div>
        </div>
      </template>
    </div>
    <div class="mapModal" :class="{ active: mapModal }">
      <img
        class="close"
        @click="mapModal = false"
        src="@/assets/images/close.svg"
      />
      <img class="mapImage" :src="activeMap" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectSeatingArea",
  props: ["seatingData", "seatingSection"],
  data() {
    return {
      mapModal: false,
      activeMap: null,
    };
  },
  methods: {
    activeClass(activeItem) {
      for (let i = 0; i < this.seatingData.length; i++) {
        if (i === activeItem) {
          this.seatingData[i].active = true;
        } else {
          this.seatingData[i].active = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#SelectSeatingArea {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  .left {
    display: flex;
    flex-direction: column;
    width: calc(50% - 13.5px);
    &__title {
      font-family: BertholdCondensed;
      font-size: 25px;
      line-height: 23px;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 16px;
      width: 100%;
      border-bottom: 1px solid rgba(255, 255, 255, 0.25);
      margin-bottom: 16px;
    }
    .seating-table {
      display: flex;
      flex-direction: column;
      &__row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px 0 27px;
        height: 50px;
        .item {
          display: flex;
          flex-direction: row;
          &.itemTitle {
            flex: 3;
          }
          &.early-bird {
            flex: 1;
          }
          &.regular {
            flex: 2;
          }
          &.tbd {
            flex: 2;
            padding-right: 17px;
          }
          .big {
            font-family: BertholdCondensed;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0;
            color: #ffffff;
            font-weight: 700;
            text-transform: uppercase;
          }
          .small {
            font-family: Gotham;
            font-size: 10px;
            line-height: 17px;
            letter-spacing: 0;
            color: #ffffff;
            font-weight: 700;
            margin-top: 4px;
          }
        }
      }
      &__row-title {
        .item {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
      }
      &__row-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-left-width: 3.01px;
        border-left-style: solid;
        border-radius: 0 4px 4px 0;
        background-color: rgba(255, 255, 255, 0.1);
        margin-bottom: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease-in-out;
        backdrop-filter: blur(5px);
        &.active {
          background: linear-gradient(180deg, #f8f8f8 0%, #c5c5c5 100%);
          transition: background-color 0.3s ease-in-out;
          .item {
            &.itemTitle,
            &.early-bird {
              color: #040c18;
            }
            &.regular {
              .regularOnly {
                color: #040c18;
              }
              .light {
                color: #040c18;
              }
            }
          }
        }
        &.allAreas {
          border: 1px solid #ffffff;
          border-radius: 4px;
        }
        .item {
          display: flex;
          flex-direction: row;
          &.itemTitle {
            font-family: BertholdCondensed;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0;
            color: #ffffff;
            font-weight: 700;
            text-transform: uppercase;
            text-align: left;
            img {
              margin-left: 10px;
            }
          }
          &.early-bird {
            display: flex;
            flex-direction: row;
            justify-content: center;
            font-family: BertholdCondensed;
            font-weight: 700;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0;
            color: #ffffff;
            transition: color 0.3s ease-in-out;
            .light {
              font-family: Gotham;
              font-weight: 300;
              font-size: 10px;
              line-height: 17px;
              letter-spacing: 0;
            }
            &__right {
              display: flex;
              flex-direction: column;
            }
          }
          &.regular {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            font-family: BertholdCondensed;
            font-weight: 700;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0;
            color: #ad2f1e;
            .strike {
              text-decoration: line-through;
            }
            .regularOnly {
              color: #ffffff;
              &-right {
                .light {
                  margin: 0;
                }
              }
            }
            .light {
              font-family: Gotham;
              font-weight: 300;
              font-size: 10px;
              line-height: 17px;
              letter-spacing: 0;
              color: #ffffff;
              text-decoration: none;
              &.start {
                margin-right: 8px;
              }
            }
            &.start {
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
            }
            .item-holder {
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
          }
        }
      }
    }
    &-disclaimer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-top: 20px;
      &__title {
        font-family: BertholdCondensed;
        font-weight: 700;
        font-size: 15px;
        line-height: 16px;
        letter-spacing: 0;
        color: #ffffff;
        text-transform: uppercase;
        margin-bottom: 8px;
      }
      &__copy {
        font-family: Gotham;
        font-weight: 300;
        font-size: 10px;
        line-height: 17px;
        letter-spacing: 0;
        text-align: start;
        color: #ffffff;
        padding-right: 15px;
        span {
          font-weight: 500;
          font-style: italic;
        }
        &.first {
          padding-bottom: 16px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.25);
          margin-bottom: 16px;
        }
      }
    }
  }
  .right {
    width: calc(50% - 13.5px);
    height: fit-content;
    border-radius: 8px;
    background-color: #ffffff;
    overflow: hidden;
    padding: 16px 16px 32px 16px;
    .seating-info {
      display: flex;
      flex-direction: column;
      width: 100%;
      .map {
        width: 100%;
        object-fit: contain;
        cursor: pointer;
      }
      &__title {
        font-family: BertholdCondensed;
        font-weight: 700;
        font-size: 25px;
        line-height: 23px;
        letter-spacing: 0;
        text-transform: uppercase;
        color: #002d74;
        border-left-width: 4px;
        border-left-style: solid;
        padding-left: 16px;
        width: fit-content;
        margin-bottom: 12px;
        margin-left: 16px;
        text-align: start;
      }
      &__middle {
        display: flex;
        width: 100%;
        padding: 0 16px;
        &.double {
          flex-direction: row;
          justify-content: space-between;
          p {
            font-family: Gotham;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0;
            text-align: left;
            color: #002d74;
            margin: 0;
            width: calc(50% - 8.5px);
          }
          .right-info {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            width: calc(50% - 8.5px);
            &__item {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-bottom: 15.06px;
              width: 100%;
              .image {
                width: 15px;
                margin-right: 14.62px;
                img {
                  height: 100%;
                  object-fit: contain;
                }
                p {
                  width: 100%;
                }
              }
              font-family: BertholdCondensed;
              font-weight: 700;
              font-size: 15px;
              line-height: 16px;
              letter-spacing: normal;
              color: #002d74;
              text-transform: uppercase;
              &.legal {
                font-family: Gotham;
                font-weight: normal;
                font-size: 10px;
                line-height: 17px;
                text-transform: initial;
                margin-top: -10px;
                text-align: left;
              }
            }
          }
        }
        &.single {
          display: flex;
          flex-direction: column;
          width: 100%;
          .single__item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 15.06px;
            .image {
              width: 15px;
              margin-right: 14.62px;
              img {
                height: 100%;
                object-fit: contain;
              }
            }
            font-family: BertholdCondensed;
            font-weight: 700;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: normal;
            color: #002d74;
            text-transform: uppercase;
            &.legal {
              font-family: Gotham;
              font-weight: normal;
              font-size: 10px;
              line-height: 17px;
              text-transform: initial;
              margin-top: -10px;
              text-align: start;
            }
          }
        }
      }
      &__carousel {
        margin-top: 32px;
        &-image {
          width: 100%;
          object-fit: contain;
          border-radius: 5px;
        }
      }
    }
  }
  .mapModal {
    position: fixed;
    top: 53.328px;
    left: 0;
    height: calc(100vh - 53.328px);
    max-height: 0;
    width: 100vw;
    overflow: hidden;
    background: #f8f8f8;
    z-index: 9999;
    transition: all 0.3s ease-in-out;
    &.active {
      max-height: calc(100vh - 53.328px);
    }
    .close {
      position: absolute;
      top: 45px;
      right: 45px;
      cursor: pointer;
    }
    .mapImage {
      height: calc(100vh - 53.328px);
      width: 100vw;
      object-fit: contain;
    }
  }
}
</style>

<style lang="scss">
#SelectSeatingArea {
  .seating-info__middle {
    span {
      color: #259ef3;
      margin-left: 4px;
    }
  }
  .seating-info__middle.double,
  .seating-info__middle.single {
    .right-info__item {
      p {
        font-family: BertholdCondensed !important;
        font-weight: 700 !important;
        font-size: 15px !important;
        line-height: 16px !important;
        letter-spacing: normal !important;
        color: #002d74 !important;
        text-transform: uppercase !important;
        width: 100% !important;
        margin-bottom: 0;
        span {
          color: #259ef3;
          margin-left: 4px;
        }
      }
    }
    .single__item {
      p {
        font-family: BertholdCondensed !important;
        font-weight: 700 !important;
        font-size: 15px !important;
        line-height: 16px !important;
        letter-spacing: normal !important;
        color: #002d74 !important;
        text-transform: uppercase !important;
        white-space: nowrap !important;
        text-align: start;
        margin-bottom: 0;
        span {
          color: #259ef3;
          margin-left: 4px;
        }
      }
    }
  }
  #SeatingAreaCarousel {
    border-radius: 5px;
    overflow: hidden;
    .carousel-control-next-icon {
      background-image: url("~@/assets/icons/icon_gallery-arrow-right.svg");
    }
    .carousel-control-prev-icon {
      background-image: url("~@/assets/icons/icon_gallery-arrow-left.svg");
    }
    .carousel-control-next-icon,
    .carousel-control-prev-icon {
      width: 70px;
      height: 70px;
    }
    .carousel-control-next,
    .carousel-control-prev {
      width: 125px;
      opacity: 1;
    }
    .carousel-control-next {
      background: linear-gradient(
        270deg,
        rgba(4, 12, 24, 0.6) 0%,
        rgba(4, 12, 24, 0) 100%
      );
    }
    .carousel-control-prev {
      background: linear-gradient(
        270deg,
        rgba(4, 12, 24, 0) 0%,
        rgba(4, 12, 24, 0.6) 100%
      );
    }
  }
}
</style>
